export default __webpack_public_path__ + "static/media/ben_majekodunmi.87fa0fc2.mp3";